import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ProspektrApi } from 'src/app/_shared/api/prospektr.api';
import { UserState } from 'src/app/_shared/state/user.state';
import constants from 'src/constant.json';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BulkFavoriteService {
  $addressVerifyStatus = new BehaviorSubject<any>(null);
  addressVerifyStatus = this.$addressVerifyStatus.asObservable();
  verificationSub: Subscription;
  verificationObservable;

  constructor(private http: HttpClient, private userState: UserState, private prospektrApi: ProspektrApi) { }

  setAddressCSV(file, name, EnableAutomatedCamp) {
    const reqData = new FormData();
    reqData.append('address', file, file.name);
    reqData.append('name', name);
    reqData.append('launchAutomatedCampaign', EnableAutomatedCamp.toString());
    // for (const [key, value] of reqData.entries()) {
    //   console.log(`${key}:`, value);
    // }
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.prospektrApi
        .uploadContacts(reqData)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res: any) => {
            observer.next(res);
          },
          (err) => {
            observer.error(err);
          }
        );
    });
  }

  //run match button click paraams==>>address id array
  startAddressVerification(addressId, groupId) {
    if (!this.userState.userDetails?.companyCode) return;
    return this.http
      .post(environment.prospektrBackendBaseURL + constants.API.startAddressVerification, {
        addressId,
        groupId,
        companyCode: this.userState.userDetails?.companyCode,
      })
      .pipe(catchError(this.handleError));
  }

  updateVerificationStatus(groupId, action) {
    const statusList: Array<any> = this.$addressVerifyStatus.getValue();
    if (action == 'add') {
      statusList.push(groupId);
    } else if (action == 'remove') {
      const groupIdIndex = statusList.indexOf(groupId);
      statusList.splice(groupIdIndex, 1);
    }
    this.$addressVerifyStatus.next(statusList);
  }

  isValidEmail(email): boolean {
    if (!email) return false;
    const validEmailRegex = RegExp(constants.regex.validEmail);
    return validEmailRegex.test(String(email).toLowerCase());
  }

  isValidAddress(street, city, state, zip): boolean {
    if ((street && city && state) || (street && zip)) return true;
    return false;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    return throwError('Something went wrong. Please try again later.');
  }
}
